module.exports = __webpack_public_path__ + "static/TangleTower8-5069b61c676038bf8f0c5e8b8bbd8ba5.png";